var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d-button-group',{staticClass:"buttons"},[_c('d-checkbox',{staticClass:"custom-toggle-sm mb-0",attrs:{"toggle":"","checked":_vm.lead.status == 'spam'},on:{"change":_vm.toggleSpam}},[_vm._v(" Spam ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }